import { EventDTO } from '@/models/EventDTO';
import { McsisConstants } from '@/models/constants/McsisConstants';
import moment from 'moment-timezone';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TimeSlotGrid extends Vue {
  @Prop({ required: true }) public slots!: EventDTO[];
  @Prop({ default: null }) public selectedSlot!: EventDTO | null;
  @Prop({ default: false }) public loading!: boolean;

  /**
   * Format time for display
   */
  public formatTime(dateStr: string): string {
    return moment(dateStr).format(McsisConstants.SlotTimeFormat);
  }

  /**
   * Check if a slot is selected
   */
  public isSelected(slot: EventDTO): boolean {
    if (!this.selectedSlot) return false;
    return (
      slot.slotId === this.selectedSlot.slotId &&
      moment(slot.start).format(McsisConstants.SlotTimeFormat) ===
        moment(this.selectedSlot.start).format(McsisConstants.SlotTimeFormat)
    );
  }

  /**
   * Select a slot
   */
  public selectSlot(slot: EventDTO): void {
    this.$emit('slotSelected', slot);
  }
}
